import React from 'react';
import { Typography } from '@mui/material';

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ icon, title }) => (
  <Typography
    variant="subtitle1"
    fontWeight={600}
    color="#1e293b"
    sx={{ mb: 1.5, display: 'flex', alignItems: 'center' }}
  >
    {icon}
    {title}
  </Typography>
);

export default SectionHeader;
